import React from "react";
import { dialogComponents } from "components/common/dialogs";
import { DialogProps } from "models/propTypes/dialogPropTypes";

const DialogContainer: React.FC<DialogProps> = (props) => {
  const DialogComponent = props.dialogType ? dialogComponents[props.dialogType] : undefined;

  return DialogComponent ? <DialogComponent {...props} /> : <></>;
};

export default DialogContainer;
